import { GlobalSearchTermModel } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ReactElement } from "react";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import {
	Icon,
	ListItem,
	Typography
} from "client/Components";
import { useGlobalSearchItemActions } from "../../../GlobalSearchItem/useGlobalSearchItemActions";

export type RecentSearchQueryViewProps = {
	item: GlobalSearchTermModel;
	itemIndex: number;
	onDelete: (id: number) => void;
	onSearch: (searchTerm: string) => void;
	tabIndex: number;
};

export const RecentSearchQueryView = (props: RecentSearchQueryViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onDelete,
		onSearch,
		tabIndex
	} = props;

	return(
		<GlobalSearchItem
			onClick={() => onSearch(item.searchTerm)}
			shouldNotAutoCloseContainingDropOver
		>
			<RecentSearchQueryListItem
				item={item}
				onDelete={onDelete}
				tabIndex={tabIndex}
				itemIndex={itemIndex}
				onExecute={() => onSearch(item.searchTerm)}
			/>
		</GlobalSearchItem>
	);
};
RecentSearchQueryView.displayName = "RecentSearchQueryView";

type RecentSearchQueryListItemProps = {
	item: GlobalSearchTermModel;
	onDelete: (id: number) => void;
	tabIndex: number;
	itemIndex: number;
	onExecute: () => void;
};
const RecentSearchQueryListItem = (props: RecentSearchQueryListItemProps): ReactElement => {
	const {
		item,
		onDelete,
		tabIndex,
		itemIndex,
		onExecute
	} = props;

	const {
		onKeyDown,
		ref
	} = useGlobalSearchItemActions({
		itemIndex,
		onExecute
	});

	return (
		<ListItem
			trackingId={`recent-search|${item.id}`}
			tabIndex={tabIndex}
			ref={ref}
			onKeyDown={onKeyDown}
		>
			<ListItem.Content
				thumbnail={
					<Icon
						value={{
							kind: "font",
							name: "clock-rotate-left",
							color: "secondary"
						}}
						size="extra-extra-large"
					/>
				}
			>
				<ListItem.Title>
					<Typography
						weight="bold"
						trackingId="title"
					>
						{item.searchTerm}
					</Typography>
				</ListItem.Title>
			</ListItem.Content>
			<ListItem.Action
				icon="xmark"
				onClick={() => onDelete(item.id)}
				bubbleClick={false}
				trackingId="delete"
			/>
		</ListItem>
	);
};
RecentSearchQueryListItem.displayName = "RecentSearchQueryListItem";